type Props = {
    header: string;
    leftColumn: string;
    children: React.ReactNode;
}

const StatsTable = ({ header, leftColumn, children }: Props) => {
    return (
        <div style={{ marginTop: "4em", marginBottom: "4em" }}>
            <h2 style={{ textAlign: "left" }}>{header}</h2>
            <table className="melee-stats-table striped">
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}>
                            <h3>{leftColumn}</h3>
                        </th>
                        <th>
                            <h3>
                                <span className="hide-mobile">Wins</span>
                                <span className="hide-desktop" style={{ marginRight: '5px' }}>W</span>
                            </h3>

                        </th>
                        <th>
                            <h3>
                                <span className="hide-mobile">Losses</span>
                                <span className="hide-desktop" style={{ marginRight: '5px' }}>L</span>
                            </h3>
                        </th>
                        <th>
                            <h3>Win Rate</h3>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    )
}

export default StatsTable;